import { OzSkeletonProductCard, PRODUCT_CARD_VARIANTS } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

export function SweepstakesCardSkeleton (): ReactElement {
    return <OzSkeletonProductCard variant={PRODUCT_CARD_VARIANTS.FLOATING} />;
}
